import { combineReducers } from 'redux';

import {
  BOOKING_GET_LOADING,
  BOOKING_GET_ERROR,
  BOOKING_GET_SUCCESS,

  BOOKING_VIEW_ERROR,
  BOOKING_VIEW_LOADING,
  BOOKING_VIEW_SUCCESS,

  BOOKING_ADD_ERROR,
  BOOKING_ADD_LOADING,
  BOOKING_ADD_SUCCESS,

  BOOKING_HAS_DO_VIEW_ERROR,
  BOOKING_HAS_DO_VIEW_LOADING,
  BOOKING_HAS_DO_VIEW_SUCCESS,

  BOOKING_HAS_DO_UPDATE_ERROR,
  BOOKING_HAS_DO_UPDATE_LOADING,
  BOOKING_HAS_DO_UPDATE_INVALID,
  BOOKING_HAS_DO_UPDATE_SUCCESS,
  BOOKING_LIST_ERROR,
  BOOKING_LIST_LOADING,
  BOOKING_LIST_SUCCESS,

  STATUS_SISA_KUOTA,
  LIST_PAY_SUCCESS,
  PAY_CHANEL_SUCCESS,
  BOOKING_REFUND
} from 'actions/constant';

import {
  BOOKING_GET_PREV_ONE_SUCCESS, 
  BOOKING_UPDATE_STAT_REDC_SUCCESS,

  EDIT_STATUS_BOOKING_LOADING, 
  EDIT_STATUS_BOOKING_SUCCESS,
  EDIT_STATUS_BOOKING_ERROR
} from 'actions/bookingAction';

const listPay = (state = {isLoad:false, val:[]}, action) => {
  switch (action.type) {
    case LIST_PAY_SUCCESS:
      return {isLoad:action.isLoad,val:action.val};
    default:
      return state;
  }
};

const BookingStatUpdate = (state = {isLoad:false, val:[],success:false, err:false, errMsg:''}, action) => {
  switch (action.type) {
    case BOOKING_UPDATE_STAT_REDC_SUCCESS:
      return {isLoad:action.Loading,val:action.data,success:action.success, err:action.error, errMsg:action.errMsg};
    default:
      return state;
  }
};

const BookingPrev = (state = {isLoad:false, val:[],success:false, err:false, errMsg:''}, action) => {
  switch (action.type) {
    case BOOKING_GET_PREV_ONE_SUCCESS:
      return {isLoad:action.Loading,val:action.data,success:action.success, err:action.error, errMsg:action.errMsg};
    default:
      return state;
  }
};

const bookingGetRefund = (state = false, action) => {
  switch (action.type) {
    case BOOKING_REFUND:
      return action.bookingGetRef;
    default:
      return state;
  }
};

const sisaKuotaKontainer = (state = {isLoad:false, val:[]}, action) => {
  switch (action.type) {
    case STATUS_SISA_KUOTA:
      return {isLoad:action.isLoad,val:action.val};
    default:
      return state;
  }
};

const pay_chanel_generate = (state = false, action) => {
  switch (action.type) {
    case PAY_CHANEL_SUCCESS:
      return action.isLoad;
    default:
      return state;
  }
};

const bookingGetError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_GET_ERROR:
      return action.bookingGetError;
    default:
      return state;
  }
};

const bookingGetLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_GET_LOADING:
      return action.bookingGetLoading;
    default:
      return state;
  }
};

const bookingGetSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_GET_SUCCESS:
      return action.bookingGetSuccess;
    default:
      return state;
  }
};

const bookings = (state = [], action) => {
  switch (action.type) {
    case BOOKING_GET_SUCCESS:
      return action.bookings;
    case BOOKING_LIST_SUCCESS:
      return action.bookings;
    default:
      return state;
  }
};

const bookingViewLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_LOADING:
      return action.bookingViewLoading;
    default:
      return state;
  }
};

const bookingViewError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_ERROR:
      return action.bookingViewError;
    default:
      return state;
  }
};

const bookingViewSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_SUCCESS:
      return action.bookingViewSuccess;
    default:
      return state;
  }
};

const booking = (state = [], action) => {
  switch (action.type) {
    case BOOKING_VIEW_SUCCESS:
      return action.booking;
    default:
      return state;
  }
};

const bookingAdded = (state = [], action) => {
  switch (action.type) {
    case BOOKING_ADD_SUCCESS:
      return action.booking;
    default:
      return state;
  }
};

const bookingAddError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_ADD_ERROR:
      return action.bookingAddError;
    default:
      return state;
  }
};

const bookingAddLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_ADD_LOADING:
      return action.bookingAddLoading;
    default:
      return state;
  }
};

const bookingAddSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_ADD_SUCCESS:
      return action.bookingAddSuccess;
    default:
      return state;
  }
};

const bookingHasDOViewError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_VIEW_ERROR:
      return action.bookingHasDOViewError;
    default:
      return state;
  }
};

const bookingHasDOViewLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_VIEW_LOADING:
      return action.bookingHasDOViewLoading;
    default:
      return state;
  }
};

const bookingHasDOViewSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_VIEW_SUCCESS:
      return action.bookingHasDOViewSuccess;
    default:
      return state;
  }
};

const bookinghdo = (state = [], action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_VIEW_SUCCESS:
      return action.bookinghdo;
    default:
      return state;
  }
};

const bookingHasDOUpdateError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_UPDATE_ERROR:
      return action.bookingHasDOUpdateError;
    default:
      return state;
  }
};

const bookingHasDOUpdateInvalid = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_UPDATE_INVALID:
      return action.bookingHasDOUpdateInvalid;
    default:
      return state;
  }
};

const invalid = (state = [], action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_UPDATE_INVALID:
      return action.invalid;
    default:
      return state;
  }
};

const bookingHasDOUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_UPDATE_LOADING:
      return action.bookingHasDOUpdateLoading;
    default:
      return state;
  }
};

const bookingHasDOUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_UPDATE_SUCCESS:
      return action.bookingHasDOUpdateSuccess;
    default:
      return state;
  }
};

const bookingListError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_LIST_ERROR:
      return action.bookingListError;
    default:
      return state;
  }
};

const bookingListLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_LIST_LOADING:
      return action.bookingListLoading;
    default:
      return state;
  }
};

const bookingListSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_LIST_SUCCESS:
      return action.bookingListSuccess;
    default:
      return state;
  }
};

const editStatusBookingLoading = (state = false, action) => {
  switch (action.type) {
    case EDIT_STATUS_BOOKING_LOADING:
      return action.editStatusBookingLoading;
    default:
      return state;
  }
};

const editStatusBookingSuccess = (state = false, action) => {
  switch (action.type) {
    case EDIT_STATUS_BOOKING_SUCCESS:
      return action.editStatusBookingSuccess;
    default:
      return state;
  }
};

const editStatusBookingData = (state = {}, action) => {
  switch (action.type) {
    case EDIT_STATUS_BOOKING_SUCCESS:
      return action.editStatusBookingData;
    default:
      return state;
  }
};

const editStatusBookingError = (state = false, action) => {
  switch (action.type) {
    case EDIT_STATUS_BOOKING_ERROR:
      return action.editStatusBookingError;
    default:
      return state;
  }
};

const bookingReducer = combineReducers({
  bookingGetRefund,
  bookingGetError,
  bookingGetLoading,
  bookingGetSuccess,
  bookings,

  bookingViewLoading,
  bookingViewError,
  bookingViewSuccess,
  booking,

  bookingAddError,
  bookingAddLoading,
  bookingAddSuccess,
  bookingAdded,

  bookingHasDOViewError,
  bookingHasDOViewLoading,
  bookingHasDOViewSuccess,
  bookinghdo,

  bookingHasDOUpdateError,
  bookingHasDOUpdateLoading,
  bookingHasDOUpdateInvalid,
  invalid,
  bookingHasDOUpdateSuccess,

  bookingListError,
  bookingListLoading,
  bookingListSuccess,
  listPay,
  pay_chanel_generate,
  sisaKuotaKontainer,

  BookingPrev,
  BookingStatUpdate,

  editStatusBookingLoading,
  editStatusBookingSuccess,
  editStatusBookingData,
  editStatusBookingError
})

export default bookingReducer;
